export const PUBLIC_LANGUAGE_OPTIONS = [
  { code: "en", shortLabel: "EN", nativeLabel: "English" },
  { code: "zh-CN", shortLabel: "简体中文", nativeLabel: "简体中文" },
  { code: "bn", shortLabel: "বাংলা", nativeLabel: "বাংলা" },
];

const SUPPORTED_PUBLIC_LANGUAGES = new Set(
  PUBLIC_LANGUAGE_OPTIONS.map((option) => option.code)
);

export function normalizePublicLanguage(language) {
  return SUPPORTED_PUBLIC_LANGUAGES.has(language) ? language : "en";
}

export function pickLanguage(language, translations) {
  if (!translations || typeof translations !== "object") return translations ?? "";
  const normalized = normalizePublicLanguage(language);
  return (
    translations[normalized] ??
    translations.en ??
    translations["zh-CN"] ??
    translations.bn ??
    Object.values(translations).find(Boolean) ??
    ""
  );
}
